import styled from "styled-components";

interface IIconBg {
  color?: string
}

export const Container = styled.div`
  margin: 36px auto 0;
  display: flex;
  flex-direction: column;
  
  @media (min-width: 980px) {
    flex-direction: row;
    margin: 40px auto 0;
    align-items: center;
  }
  
  @media (min-width: 1280px) {
    width: 1150px;
  }
`

export const Left = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 32px;
  
  @media (min-width: 980px) {
    flex: 0 0 50%;
    margin-bottom: 0;
    padding-right: 32px;
  }
`

export const Right = styled.div`
  margin-bottom: 40px;
  
  @media (min-width: 980px) {
    margin-bottom: 0;
    flex: 0 0 50%;
    padding-left: 32px;
  }
`

export const IconWrapp = styled.div`
  width: 342px;
  height: 230px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const IconBg = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  
  &::before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 227px;
    height: 180px;
    background: #D4D3FF;
    border-radius: 20px;
  }
  
  &::after {
    content: '';
    display: block;
    position: absolute;
    right: 0;
    bottom: 0;
    width: 163px;
    height: 128px;
    background: #F7D5F0;
    border-radius: 20px;
  }
`

export const IconPlace = styled.div`
  padding: 25px 25px 35px 25px;
  margin-left: 27px;
  margin-top: 15px;
  background: #FFFFFF;
  border: 1px solid #C4BFD4;
  border-radius: 16px;
  position: absolute;
  font-weight: 700;
  font-size: 20px;
  line-height: 140%;
  color: #4E4963;
  text-align: center;
`

export const IconPlaceCost = styled.span`
  font-size: 36px;
  line-height: 160%;
`

export const ListTitle = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 160%;
  color: #2A2637;
  margin-bottom: 12px;

  @media(min-width: 980px) {
    font-size: 18px;
  }
`

export const List = styled.ul`
  margin: 0;
  padding: 0 0 0 20px;
  list-style: circle;
`

export const ListItem = styled.li`
  font-weight: 500;
  font-size: 14px;
  line-height: 160%;
  color: #2A2637;
  margin-bottom: 12px;
  
  &:last-child {
    margin-bottom: 0;
  }

  @media(min-width: 980px) {
    font-size: 18px;
  }
`

export const CostContainer = styled.div`
  margin-bottom: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media(min-width: 980px) {
    justify-content: center;
    flex-direction: row;
    margin-bottom: 60px;
    margin-top: 50px;
  }
`

export const CostCol = styled.div`
  padding: 28px 0;
  position: relative;

  &::after {
    content: '';
    display: block;
    position: absolute;
    height: 1px;
    width: 50px;
    background: #E0DDEC;
    bottom: 0;
    margin-left: -25px;
    left: 50%;
  }
  
  &:last-child {
    &::after {
      display: none;
    }
  }

  @media(min-width: 980px) {
    padding: 0 40px;

    &::after {
      height: 50px;
      width: 1px;
      top: 50%;
      margin-top: -25px;
      right: 0;
      left: inherit;
      bottom: inherit;
      margin-left: auto;
    }
  }
`

export const CostHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`

export const CostTitle = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 140%;
  color: #4E4963;
`

export const CostIcon = styled.div`
  margin-right: 8px;
`

export const CostBody = styled.div`
  display: flex;
`

export const CostFromText = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  color: #4E4963;
  align-self: flex-end;
  margin-right: 12px;
`

export const CostText = styled.div`
  font-weight: 700;
  font-size: 56px;
  line-height: 100%;
  color: #797199;
  margin-right: 12px;
`

export const CostUnitsText = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  color: #4E4963;
  align-self: flex-end;
`
export const NoteBlock = styled.div`
  
  background: #FAEFE4;
  border-radius: 24px;
  margin: 0 auto;
  padding: 24px 36px;
  text-align: center;

  @media(min-width: 980px) {
    width: 798px;
  }
`

export const NoteTitle = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 160%;
  color: #4E4963;
  margin-bottom: 17px;
  
  @media(min-width: 980px) {
    font-size: 20px;
    line-height: 140%;
  }
`

export const NoteText = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: #2A2637;
  line-height: 160%;

  @media(min-width: 980px) {
    font-size: 18px;
  }
`